function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 3a1 1 0 011 1v12a1 1 0 01-1 1h-3v3a1 1 0 01-1 1H5a1 1 0 01-1-1V8a1 1 0 011-1h3V4a1 1 0 011-1h10zM8 8.5H5.5v11h9V17H9a1 1 0 01-1-1V8.5zm10.5-4h-9v11h9v-11z",
  fill: "#FFF",
  fillRule: "evenodd"
});
function SvgCopyToClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboard);
export default __webpack_public_path__ + "static/media/copy-to-clipboard.27912438.svg";
export { ForwardRef as ReactComponent };